/**
 * Tests for fetch support
 */
export default ((): boolean => !!window.fetch || false)();
